import React from 'react';
import cn from 'classnames';

import { Link } from 'react-router-dom';

export const ActionBtnType = {
  BLOCK: 'BLOCK',
  LINK: 'LINK',
  LINK_DANGER: 'LINK_DANGER',
};

const ActionBlock = ({ icon, title, subTitle, action }) => {
  return (
    <div className="action-item action-item_block" onClick={action}>
      <div className="action-item__head">
        {icon}
        <span className="action-item__title">{title}</span>
      </div>
      <span className="action-item__description">{subTitle}</span>
    </div>
  );
};

const ActionLink = ({ icon, title, type, action }) => {
  return (
    <div
      onClick={action}
      className={cn(
        'action-item action-item_link',
        { [`action-item_link-${type}`]: type },
      )}

    >
      {icon} <span>{title}</span>
    </div>
  );
};

const ActionMenuItem = ({ type, path, ...props }) => {
  const renderActionComponent = (Component, props) => {
    if (path) return <Link className="action-item__container" to={path}><Component {...props} /></Link>;

    return <div className="action-item__container"><Component {...props} /></div>;
  };

  switch (type) {
    case ActionBtnType.BLOCK:
      return renderActionComponent(ActionBlock, props);
    case ActionBtnType.LINK_DANGER:
      return renderActionComponent(ActionLink, { ...props, type: 'danger' });
    default:
      return renderActionComponent(ActionLink, props);
  }
};

export default ActionMenuItem;
